export const EDIT_PATH = '/edit';
export const CREATE_PATH = '/create';
export const INTERVIEW_PATH = '/interview';
export const VIEW_PATH = '/view';
